/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront } from './FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront';
import {
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSONTyped,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSON,
    FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSONTyped,
} from './FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront';

/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore
     */
    Url: string;
    /**
     * 
     * @type {FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore
     */
    StoreFront: FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFront;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore {
    if (!('Url' in value) || value['Url'] === undefined) return false;
    if (!('StoreFront' in value) || value['StoreFront'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore {
    if (json == null) {
        return json;
    }
    return {
        
        'Url': json['url'],
        'StoreFront': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontFromJSON(json['store_front']),
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStoreToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoFeatureStore | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'url': value['Url'],
        'store_front': FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontToJSON(value['StoreFront']),
    };
}

